module.exports = __webpack_public_path__ + "img/cp5-6.4f5f1883.jpg";